<template>
    <div>
        <div class="main-content">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">Dados da Reserva</div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-10">
                                    <form action>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label for="carUser">Nome do Usuário</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.user.name"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="carDateStart">Data de Retirada</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.retreat_date"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="carDateEnd">Data de Devolução</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.devolution_date"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-6" v-if="reserve.justification">
                                                <div class="form-group">
                                                    <label for="justifications">
                                                        <span class="required">*</span> Justificativa
                                                    </label>
                                                    <textarea
                                                        class="form-control"
                                                        id="justifications"
                                                        v-model="reserve.justification.description"
                                                        disabled
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="reason">
                                                        <span class="required">*</span> Motivo da Reserva
                                                    </label>
                                                    <textarea
                                                        class="form-control"
                                                        id="reason"
                                                        v-model="reserve.reason"
                                                        disabled
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <div class="form-group">
                                                    <label for="carSpot">Filial</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.branch.description"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="carPlate">Status Atual da Reserva</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.reserve_status.title"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div></div>
                                        <div
                                            v-if="
                        reserve.reserve_status.id == 4 ||
                        reserve.reserve_status.id == 5
                      "
                                        >
                                            <label for="carSpot">Dados de Check-List</label>
                                            <div class="buttons">
                                                <a
                                                    href="#"
                                                    class="btn btn-add float-md-left"
                                                    data-dismiss="modal"
                                                    data-toggle="modal"
                                                    data-target="#modalCheckin"
                                                >Visualizar Check-List</a
                                                >
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="col-md-2">
                                    <div class="circular--landscape">
                                        <img :src="reserve.user.photo" width="100%" height="198"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-header">
                            <div class="card-title">Dados do Veículo</div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-10">
                                    <form action>
                                        <div class="row">
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <label for="carUser">Descrição</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.vehicles.description"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="carDateStart">Placa</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.vehicles.board"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="carType">Tipo do Veículo</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.vehicle_type_id.description"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <div class="text">Km Rodados:</div>
                                                    <div class="data km-total">
                                                        <the-mask
                                                            disabled
                                                            class="form-control"
                                                            :value="reserve.vehicles.current_km"
                                                            :mask="['####', '#.###', '##.###', '###.###']"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="carType">Combustível</label>
                                                    <input
                                                        type="text"
                                                        :value="reserve.vehicles.combustible"
                                                        class="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="col-md-2">
                                    <img :src="reserve.vehicles.photo" class="car-pic"/>
                                </div>
                            </div>
                        </div>

                        <div class="card-header">
                            <div class="card-title">Histórico da Reserva</div>
                        </div>

                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th scope="col" style="width: 30%">
                                    Data e Hora da Atualização
                                </th>
                                <th scope="col" style="width: 20%">Status</th>
                                <th scope="col">Observação</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="h in history" :key="h.id">
                                <td>{{ h.created_at }}</td>
                                <td>{{ h.reserve_status.title }}</td>
                                <td>{{ h.observation }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="col-md-12 text-right">
                            <router-link to="/reserveVehicles" class="btn btn-back">
                                <i class="fa fa-arrow-left"></i> Voltar
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Checkin -->

        <div
            class="modal fade"
            id="modalCheckin"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modalCheckinTitle"
            v-if="reserve.reserve_status.id == 4 || reserve.reserve_status.id == 5"
        >
            <div
                class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg
        "
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalCheckinTitle">
                            Check-List do Veículo
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-5">
                                <img class="car-pic" :src="reserve.vehicles.photo" alt/>
                            </div>
                            <div class="col-md-7">
                                <div class="car-info">
                                    <div class="car-desc">
                                        <div class="text">{{ reserve.vehicles.description }}</div>
                                        <div class="data">{{ reserve.vehicles.board }}</div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="car-desc">
                                        <div class="text">Reservado Para:</div>
                                        <div class="data">
                                            {{ reserve.user.name }}
                                            <button
                                                class="btn btn-user"
                                                data-tooltip="tooltip"
                                                title="Dados do Usuário"
                                                data-dismiss="modal"
                                                data-toggle="modal"
                                                data-target="#modalVisualizar"
                                            >
                                                <i class="fas fa-user"></i>
                                            </button>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="car-desc">
                                        <div class="text">Retirada Estimada:</div>
                                        <div class="data">{{ reserve.retreat_date }}</div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="car-desc">
                                        <div class="text">Retirado Em:</div>
                                        <div class="data">{{ reserve && reserve.checkout ? reserve.checkout.retreat_at : '' }}</div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="car-desc">
                                        <div class="text">Devolução Estimada:</div>
                                        <div class="data">{{ reserve.devolution_date }}</div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="car-desc" v-if="reserve.reserve_status.id == 5">
                                        <div class="text">Devolvido Em:</div>
                                        <div class="data">{{ reserve.checkin.devoluted_at }}</div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="car-desc">
                                        <div class="text">Km Rodados:</div>
                                        <div class="data km-total">
                                            <the-mask
                                                disabled
                                                class="km-in-modal"
                                                :value="this.vehicleKM"
                                                :mask="['####', '#.###', '##.###', '###.###']"
                                            />
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul
                            class="nav nav-pills nav-justified"
                            id="pills-tab"
                            role="tablist"
                        >
                            <li class="nav-item">
                                <a
                                    class="nav-link active"
                                    id="pills-checkout02-tab"
                                    data-toggle="pill"
                                    href="#pills-checkout02"
                                    role="tab"
                                    aria-controls="pills-checkout02"
                                    aria-selected="false"
                                >Check-Out</a
                                >
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    id="pills-checkin02-tab"
                                    data-toggle="pill"
                                    href="#pills-checkin02"
                                    role="tab"
                                    aria-controls="pills-checkin02"
                                    aria-selected="true"
                                >Check-In</a
                                >
                            </li>
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div
                                class="tab-pane fade show active"
                                id="pills-checkout02"
                                role="tabpanel"
                                aria-labelledby="pills-checkout02-tab"
                            >
                                <div class="row mt-3">
                                    <div class="col-md-7">
                                        <div class="check-part">Km no momento do check-out</div>
                                        <div class="new-km mb-3">
                                            <span>{{ reserve && reserve.checkout ? reserve.checkout.km_checkout : '' }}</span> km
                                        </div>
                                        <div class="check-part">Combustível</div>
                                        <div class="row pl-3 pr-3 mb-3">
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve && reserve.checkout &&reserve && reserve.checkout &&reserve.checkout.combustible == '0' ? 'check' : '',
                        ]"
                                            >
                                                0
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve && reserve.checkout &&reserve.checkout.combustible == '1/4' ? 'check' : '',
                        ]"
                                            >
                                                1/4
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve && reserve.checkout &&reserve.checkout.combustible == '1/2' ? 'check' : '',
                        ]"
                                            >
                                                1/2
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve && reserve.checkout &&reserve.checkout.combustible == '3/4' ? 'check' : '',
                        ]"
                                            >
                                                3/4
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve && reserve.checkout &&reserve.checkout.combustible == '7/8' ? 'check' : '',
                        ]"
                                            >
                                                7/8
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve && reserve.checkout &&reserve.checkout.combustible == 'Cheio'
                            ? 'check'
                            : '',
                        ]"
                                            >
                                                Cheio
                                            </div>
                                        </div>
                                        <div class="check-part">Avarias</div>
                                        <div class="car-damage mb-3">
                                            <div class="dmg-position">
                                                Frontal
                                                <span>
                          {{ reserve && reserve.checkout ? reserve.checkout.bkd_frontal.description : '' }}
                        </span>
                                            </div>
                                            <div class="dmg-position">
                                                Lateral Direita
                                                <span>
                          {{ reserve && reserve.checkout ? reserve.checkout.bkd_right_side.description : '' }}
                        </span>
                                            </div>
                                            <div class="dmg-position">
                                                Traseira
                                                <span>
                          {{ reserve && reserve.checkout ? reserve.checkout.bkd_rear.description : '' }}
                        </span>
                                            </div>
                                            <div class="dmg-position">
                                                Lateral Esquerda
                                                <span>
                          {{ reserve && reserve.checkout ? reserve.checkout.bkd_left_side.description : '' }}
                        </span>
                                            </div>
                                            <div class="dmg-position">
                                                Teto
                                                <span>
                          {{ reserve && reserve.checkout ? reserve.checkout.bkd_ceiling.description : '' }}
                        </span>
                                            </div>
                                        </div>
                                        <div class="check-part">Adicionais</div>
                                        <div class="car-adds mb-3">
                                            <div
                                                class="car-add"
                                                v-for="ci in checklist_items"
                                                :key="ci.id"
                                            >
                                                <div class="add-type">{{ ci.description }}</div>
                                                <div class="custom-control custom-switch" v-if="reserve.checkout">
                                                    <div
                                                        v-for="vi in reserve.checkout.checklist_itens"
                                                        :key="vi.id"
                                                    >
                                                        <div v-show="vi.id == ci.id">
                                                            <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                :id="ci.id + 'b'"
                                                                :checked="vi.id == ci.id"
                                                            />
                                                            <label
                                                                class="custom-control-label"
                                                                :for="ci.id + 'b'"
                                                            ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="damages-check">
                                            <img
                                                src="../../assets/../assets/images/damages.png"
                                                alt
                                            />
                                            <div
                                                :class="[
                          reserve && reserve.checkout && reserve.checkout.bkd_frontal.id > 1
                            ? 'damage-pin pin-04'
                            : '',
                        ]"
                                            ></div>
                                            <div
                                                :class="[
                          reserve && reserve.checkout && reserve.checkout.bkd_right_side.id > 1
                            ? 'damage-pin pin-03'
                            : '',
                        ]"
                                            ></div>
                                            <div
                                                :class="[
                          reserve && reserve.checkout && reserve.checkout.bkd_left_side.id > 1
                            ? 'damage-pin pin-01'
                            : '',
                        ]"
                                            ></div>
                                            <div
                                                :class="[
                          reserve && reserve.checkout && reserve.checkout.bkd_rear.id > 1
                            ? 'damage-pin pin-02'
                            : '',
                        ]"
                                            ></div>
                                            <div
                                                :class="[
                          reserve && reserve.checkout && reserve.checkout.bkd_ceiling.id > 1
                            ? 'damage-pin pin-05'
                            : '',
                        ]"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <div class="check-part">Outras Anotações</div>
                                        <div class="check-text">{{ reserve && reserve.checkout ? reserve.checkout.notes : '' }}</div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <div style="text-align: center">
                                            <a
                                                @click="showMultiple(reserve.checkout)"
                                                class="btn btn-photo max"
                                            >
                                                Visualizar fotos do Check-Out
                                                <i class="fas fa-camera"></i>
                                                <br/>
                                            </a>
                                        </div>
                                        <br/>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="tab-pane fade"
                                v-if="reserve.reserve_status.id == 4"
                                id="pills-checkin02"
                                role="tabpanel"
                                aria-labelledby="pills-checkin02-tab"
                            >
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <div class="no-check">Check-In não realizado.</div>
                                        <div class="no-check-data">
                                            Devolução estimada para
                                            <span>{{ reserve.devolution_date }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="tab-pane fade"
                                v-if="reserve.reserve_status.id == 5"
                                id="pills-checkin02"
                                role="tabpanel"
                                aria-labelledby="pills-checkin02-tab"
                            >
                                <div class="row mt-3">
                                    <div class="col-md-7">
                                        <div class="check-part">Km Atual</div>
                                        <div class="new-km mb-3">
                                            <span>{{ reserve.checkin.atual_km }}</span> km
                                        </div>
                                        <div class="check-part">Combustível</div>
                                        <div class="row pl-3 pr-3 mb-3">
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve.checkin.combustible == '0' ? 'check' : '',
                        ]"
                                            >
                                                0
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve.checkin.combustible == '1/4' ? 'check' : '',
                        ]"
                                            >
                                                1/4
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve.checkin.combustible == '1/2' ? 'check' : '',
                        ]"
                                            >
                                                1/2
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve.checkin.combustible == '3/4' ? 'check' : '',
                        ]"
                                            >
                                                3/4
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve.checkin.combustible == '7/8' ? 'check' : '',
                        ]"
                                            >
                                                7/8
                                            </div>
                                            <div
                                                class="col-2 gas"
                                                :class="[
                          reserve.checkin.combustible == 'Cheio' ? 'check' : '',
                        ]"
                                            >
                                                Cheio
                                            </div>
                                        </div>
                                        <div class="check-part">Avarias</div>
                                        <div class="car-damage mb-3">
                                            <div class="dmg-position">
                                                Frontal
                                                <span>
                          {{ reserve.checkin.bkd_frontal.description }}
                        </span>
                                            </div>
                                            <div class="dmg-position">
                                                Lateral Direita
                                                <span>
                          {{ reserve.checkin.bkd_right_side.description }}
                        </span>
                                            </div>
                                            <div class="dmg-position">
                                                Traseira
                                                <span>
                          {{ reserve.checkin.bkd_rear.description }}
                        </span>
                                            </div>
                                            <div class="dmg-position">
                                                Lateral Esquerda
                                                <span>
                          {{ reserve.checkin.bkd_left_side.description }}
                        </span>
                                            </div>
                                            <div class="dmg-position">
                                                Teto
                                                <span>
                          {{ reserve.checkin.bkd_ceiling.description }}
                        </span>
                                            </div>
                                        </div>

                                        <div class="check-part">Adicionais</div>
                                        <div class="car-adds mb-3">
                                            <div
                                                class="car-add"
                                                v-for="co in checklist_items"
                                                :key="co.id"
                                            >
                                                <div class="add-type">{{ co.description }}</div>
                                                <div class="custom-control custom-switch">
                                                    <div
                                                        v-for="vo in reserve.checkin.checklist_itens"
                                                        :key="vo.id"
                                                    >
                                                        <div v-show="vo.id == co.id">
                                                            <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                :id="co.id + 'b'"
                                                                :checked="vo.id == co.id"
                                                                disabled
                                                            />
                                                            <label
                                                                class="custom-control-label"
                                                                :for="co.id + 'b'"
                                                            ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="damages-check">
                                            <img
                                                src="../../assets/../assets/images/damages.png"
                                                alt
                                            />
                                            <div
                                                :class="[
                          reserve.checkin.bkd_frontal.id > 1
                            ? 'damage-pin pin-04'
                            : '',
                        ]"
                                            ></div>
                                            <div
                                                :class="[
                          reserve.checkin.bkd_right_side.id > 1
                            ? 'damage-pin pin-03'
                            : '',
                        ]"
                                            ></div>
                                            <div
                                                :class="[
                          reserve.checkin.bkd_left_side.id > 1
                            ? 'damage-pin pin-01'
                            : '',
                        ]"
                                            ></div>
                                            <div
                                                :class="[
                          reserve.checkin.bkd_rear.id > 1
                            ? 'damage-pin pin-02'
                            : '',
                        ]"
                                            ></div>
                                            <div
                                                :class="[
                          reserve.checkin.bkd_ceiling.id > 1
                            ? 'damage-pin pin-05'
                            : '',
                        ]"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <div class="check-part">Outras Anotações</div>
                                        <div class="check-text">{{ reserve.checkin.notes }}</div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <div style="text-align: center">
                                            <a
                                                @click="showMultiple(reserve.checkin)"
                                                class="btn btn-photo max"
                                            >
                                                Visualizar fotos do Check-In
                                                <i class="fas fa-camera"></i>
                                                <br/>
                                            </a>
                                        </div>
                                        <br/>
                                        <div class="row"></div>
                                        <!-- <vue-image-lightbox-carousel
                                          ref="lightbox"
                                          :show="showLightbox"
                                          @close="showLightbox = false"
                                          :images="imagesCheckin"
                                          @change="changeImage"
                                        ></vue-image-lightbox-carousel>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template>
            <vue-easy-lightbox
                :visible="visible"
                :imgs="imgs"
                @hide="handleHide"
            ></vue-easy-lightbox>
        </template>
    </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";

export default {
    components: {VueEasyLightbox},
    data() {
        return {
            imgs: "", // Img Url , string or Array
            visible: false,
            index: 0, // default
            reserve: {
                user: {
                    name: "",
                },
                branch: {
                    description: "",
                },
                vehicle_type_id: {
                    description: "",
                },
                reserve_status: {
                    title: "",
                },
                vehicles: {
                    description: "",
                    board: "",
                },
            },
            history: [],
            errors: undefined,
            name: "",
            checklist_items: [{}],
            ciCount: "",
        };
    },
    computed: {},
    methods: {
        showMultiple(data) {
            this.imgs = [
                data.photo1,
                data.photo2,
                data.photo3,
                data.photo4,
                data.photo5,
                data.photo6,
            ];
            this.index = 1; // index of imgList
            this.show();
        },

        show() {
            this.visible = true;
        },
        handleHide() {
            this.visible = false;
        },
        getReserve: function () {
            let self = this;
            let id = self.$route.params.id;
            let api =
                self.$store.state.api +
                "reserveVehicles/" +
                id +
                "?with[]=user&with[]=branch&with[]=vehicle_type_id&with[]=reserve_status&with[]=vehicles&with[]=checkout&with[]=checkin&with[]=justification";

            self.$http
                .get(api)
                .then((response) => {
                    self.reserve = response.data.data[0];
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, self.errors, "error");
                });
        },
        getHistory: function () {
            let self = this;
            let id = self.$route.params.id;
            let api =
                self.$store.state.api +
                "reserveVehiclesHistory/?paginated=false&reserve_id=" +
                id +
                "&with[]=reserve_status";
            self.$http
                .get(api)
                .then((response) => {
                    self.history = response.data.data;
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, self.errors, "error");
                });
        },
        getChecklistItens: function () {
            const self = this;
            const api = self.$store.state.api + "checklistItems/";

            self.$http
                .get(api)
                .then((response) => {
                    self.checklist_items = response.data.data;
                    self.ciCount = response.data.count;

                    for (let i = 0; i < self.ciCount; i++) {
                        if (
                            self.checklist_items[i].id == 1 ||
                            self.checklist_items[i].id == 3
                        ) {
                            self.checked[i] = true;
                        } else {
                            self.checked[i] = false;
                        }
                    }
                })
                .catch((error) => {
                });
        },
    },
    mounted: function () {
        this.getReserve();
        this.getHistory();
        this.getChecklistItens();
    },
};
</script>
<style scoped>
.max {
    width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/View.vue